import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ScripturalReferenceMasterState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allScripturalReferenceList: any[];
}

const initialState: ScripturalReferenceMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allScripturalReferenceList: [],
};

export const scripturalReferenceMasterSlice = createSlice({
  name: 'scripturalReferenceMaster',
  initialState,
  reducers: {
    setScripturalReferences: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setScripturalReferencesBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllScripturalReferences: (state, action) => {
      state.allScripturalReferenceList = action.payload.data;
    },
    resetScripturalReference: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setScripturalReferences,
  setScripturalReferencesBySearch,
  setAllScripturalReferences,
  resetScripturalReference,
} = scripturalReferenceMasterSlice.actions;

export const getScripturalReferenceData = (state: RootState) => state.scripturalReferenceMaster.data;
export const getAllScripturalReferenceList = (state: RootState) => state.scripturalReferenceMaster.allScripturalReferenceList;
export const getScripturalReferenceTotalRecords = (state: RootState) => state.scripturalReferenceMaster.totalRecords;
export const getScripturalReferenceDataBySearch = (state: RootState) => state.scripturalReferenceMaster.data;

export default scripturalReferenceMasterSlice.reducer;
